import { useState } from 'react';

import SelectField from '@rewardopl/react-ui/select_field';

export default function UncontrolledSelectField({
  value: valueProps,
  ...otherProps
}: React.ComponentProps<typeof SelectField>) {
  const [value, setValue] = useState(valueProps);

  return <SelectField {...otherProps} onChange={setValue} value={value} />;
}
